import { render, staticRenderFns } from "./ProductUnit.vue?vue&type=template&id=1277a45f"
import script from "./ProductUnit.vue?vue&type=script&lang=js"
export * from "./ProductUnit.vue?vue&type=script&lang=js"
import style0 from "./ProductUnit.vue?vue&type=style&index=0&id=1277a45f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports